<template>
    <el-dialog
        title="刷卡"
        v-model="dialogVisible"
        width="527px"
        class="readcard"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true">
        <swipeComp :readcard="readcard" @upSwipe="upSwipe" />
    </el-dialog>
</template>

<script>
import swipeComp from '@/components/clientSide/common/swipe.vue'

export default {
    name: 'mutual-swipe-index',
    components: {
        swipeComp
    },
    data () {
        return {
            dialogVisible: false,
            readcard: {
                addnotic: "提交成功",
                addpic: "https://bigdata.topeti.com/PCRepository/mainPlatform/noData.svg",
                classify: "idCard",
                commit:1,
                feildList: [],
                loadnotic: "请将卡轻触读卡器进行刷卡",
                loadpic: "https://bigdata.topeti.com/PCRepository/mainPlatform/swipe.svg",
                open: true
            }
        }
    },
    methods: {
        open (item) {
            console.log('打开刷卡弹窗', item)
            this.readcard.classify = item.classify
            this.readcard.feildList = (item.newlyAdded || []).map(it => {
                return {
                    card: it.orgName,
                    field: it.filedName
                }
            })
            this.dialogVisible = true
        },
        upSwipe (val) {
            console.log('刷卡返回', val)
            this.$emit('swipeRet', val)
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .rearward {
  border-radius: 10px;
  .el-dialog__header {
    padding: 10px 20px;
    background-color: #EEEEEE;
    border-radius: 10px 10px 0 0;
    .el-dialog__title {
      font-size: 14px;
      color: #333333;
    }
    .el-dialog__headerbtn {
      font-size: 18px;
      color: #999999;
      top: 11px;
      right: 15px;
    }
  }
}
::v-deep .swipe {
    border-left: none !important;
    margin-left: auto;
    margin-right: auto;
}
</style>
